import React from 'react'
import { NavLink } from 'react-router-dom'
import { FaFacebook } from 'react-icons/fa';
import { AiFillInstagram } from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';
import { BsBehance } from 'react-icons/bs';
import { BiLogoGmail } from 'react-icons/bi';
import { BiSolidPhoneCall } from 'react-icons/bi';
import { FaTiktok } from 'react-icons/fa';
import { AiOutlineAlignRight } from 'react-icons/ai';
import { BsWhatsapp } from 'react-icons/bs';
const Navbar = () => {
    return (
        <>
            <div class="offcanvas p-0 m-0 offcanvas-bottom" tabindex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
                <div class="offcanvas-header">
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                    <section className='top-icons'>
                        <div className="container">
                            <NavLink to="tel:923245097351"><BiSolidPhoneCall />&nbsp; Phone</NavLink>
                            <NavLink to="https://wa.me/+923245097351?text=I need you can you help me plz..."><BsWhatsapp />&nbsp; WhatsApp</NavLink>
                            <NavLink to="mailto:ranarizwan7351@gmail.com"><BiLogoGmail />&nbsp; Gmail</NavLink>
                            <NavLink to="https://www.facebook.com/profile.php?id=100090649845449"><FaFacebook />&nbsp; Facebook</NavLink>
                            <NavLink to="https://www.linkedin.com/in/muhammad-rizwan-82031a235/"><FaLinkedinIn />&nbsp; Linkedin</NavLink>
                            <NavLink to="https://www.instagram.com/ranarizwan7351/"><AiFillInstagram />&nbsp; Instagram</NavLink>
                            <NavLink to="https://www.behance.net/ranarizwan4"><BsBehance />&nbsp; Behance</NavLink>
                            <NavLink to="https://www.tiktok.com/@ranarizwan7351"><FaTiktok />&nbsp; Tiktok</NavLink>
                        </div>
                    </section>
                </div>
            </div>
            <nav className="navbar navbar-expand-sm m-0 p-0">
                <div className="container">
                    <NavLink className="navbar-brand animate__animated animate__pulse animate__infinite	infinite" to="/">Muhammad Rizwan</NavLink>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <h1 className='text-white p-0 m-0'><AiOutlineAlignRight /></h1>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                            <li className="nav-item"><NavLink className="nav-link" to="/">Home</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/about">About</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/Services">Services</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/Portfolio">Portfolio</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/Projects">Projects</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/Contact">Contact</NavLink></li>
                        </ul>
                        <div><button className=" btn-button p-1 m-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">Socail</button>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}
export default Navbar